module.exports = __webpack_public_path__ + "img/caret-left.fd9384c1.svg";